export default __webpack_public_path__ + "static/smi-conformance-result-e606fa66f759ec96d0f93acb8c2567c5.webp";